import React from 'react';
import intersectionHelper from '../../../general/js/intersection-helper';
import PropTypes from 'prop-types';

export default class ListingLoadMore extends React.PureComponent {
    constructor(props) {
        super(props);

        this.setLoadMoreElement = this.setLoadMoreElement.bind(this);
        this.loadMore = this.loadMore.bind(this);
    }

    componentWillUnmount() {
        if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
        }
    }

    render() {

        if (this.props.isLoadingMore) {
            return (
                <div className="listing__load-more">
                    <div className="loading-gif"></div>
                    <div className="listing__load-more-caption">
                        loading more lots...
                    </div>
                </div>
            )
        } else {
            let shouldHandleLoadMore = this.props.pagination &&
                (this.props.pagination.currentPage < this.props.pagination.pageCount);

            if (shouldHandleLoadMore) {
                return (
                    <div className="listing__load-more" ref={this.setLoadMoreElement}>
                        <div className="btn btn--blue" onClick={this.loadMore}>load more</div>
                    </div>
                )
            } else {
                return '';
            }
        }
    }

    setLoadMoreElement(element) {
        if (this.observer) {
            this.observer.disconnect();
        }
        if (element) {
            this.observer = intersectionHelper.enterViewport(element, this.loadMore, {
                rootMargin: '0px 0px 50% 0px'
            });
        }
    }

    loadMore() {
        this.props.onLoadMore();
    }
}

ListingLoadMore.propTypes = {
    isLoadingMore: PropTypes.bool.isRequired,
    pagination: PropTypes.object.isRequired,
};





// WEBPACK FOOTER //
// ./app/components/listing/js/ListingLoadMore.js